import React, { Suspense, lazy } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  useLocation,
} from 'react-router-dom';
import Main from './layouts/Main';
import './static/css/main.scss';

const { PUBLIC_URL } = process.env;

const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Index = lazy(() => import('./pages/Index'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Projects = lazy(() => import('./pages/Projects'));
const Resume = lazy(() => import('./pages/Resume'));
const Stats = lazy(() => import('./pages/Stats'));

const routeMeta = {
  '/': {
    description:
      "Yasin Boelhouwer's personal website. New York based Stanford ICME graduate, "
      + 'VP of Engineering at Smile Identity, co-founder of Arthena and Matroid, and YC Alumni.',
  },
  '/about': {
    title: 'About',
    description: 'Learn about Yasin Boelhouwer',
  },
  '/projects': {
    title: 'Projects',
    description: "Learn about Yasin Boelhouwer's projects.",
  },
  '/stats': {
    title: 'Stats',
    description: 'Some statistics about Yasin Boelhouwer',
  },
  '/contact': {
    title: 'Contact',
    description: 'Contact Yasin Boelhouwer via email @ info@yasin.nu',
  },
  '/resume': {
    title: 'Resume',
    description: 'Yasin Boelhouwer Resume.',
  },
};

const PageLayout = () => {
  const { pathname } = useLocation();
  const meta = routeMeta[pathname] || {};

  return (
    <Main {...meta}>
      <Outlet />
    </Main>
  );
};

const App = () => (
  <BrowserRouter
    basename={PUBLIC_URL}
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <Suspense fallback={<Main />}>
      <Routes>
        <Route element={<PageLayout />}>
          <Route index element={<Index />} />
          <Route path="about" element={<About />} />
          <Route path="projects" element={<Projects />} />
          <Route path="stats" element={<Stats />} />
          <Route path="contact" element={<Contact />} />
          <Route path="resume" element={<Resume />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default App;
